import '../src/style/common.css'
import '../src/style/style.css'


export * from './components/WalletStatement'
export * from './components/RegionWiseBranches'
export * from './components/truckTypes'
export * from './components/TrackingUi'
export * from './components/AllLoadsComponent/AllLoads'
export * from './components/truckRates'
export * from './components/dailyRates'
export * from './components/AllLoadsComponent/TripCard'
export * from './components/AllLoadsComponent/AllLoadsFilter'
export * from './components/SearchLoads'
export * from './components/LanguageFilter';
export * from './components/EwayBillModal';
export * from './components/InstantLrApprovalUI';